export const SkipDeleteRedirectQueryKey = 'sdr';
